<template>
  <!-- _________________________ RESET PASSWORD _________________________ -->
  <div id="login-div">

    <b-alert :show="ui.showError" variant="danger">
      {{ ui.showErrorMessage }}
    </b-alert>

    <b-alert :show="ui.showSuccess" variant="success" class="mt-5">
      {{ $t('ChangePassword.success') }}
      <br/>
    </b-alert>

    <div v-if="!ui.showError && !ui.showSuccess">
      <h1 class="page-title mt-4">
        {{ $t('ChangePassword.newPassword') }}
      </h1>

      <form ref="form" @submit.stop.prevent="handleSubmit" class="mt-4">

        <!-- New password -->
        <b-form-group
          :label="$t('NewPassword')"
          label-for="newPassword-input"
          :invalid-feedback="form.newPassword.invalidFeedback"
          :state="form.newPassword.state">
          <div class="login-password-container">
            <b-form-input
              id="newPassword-input"
              class="password-input-with-an-eye"
              v-model="form.newPassword.value"
              :state="form.newPassword.state"
              :type="showNewPassword ? 'text' : 'password'"
              autocomplete="off"
              required>
            </b-form-input>
            <div class="login-show-password-btn" @click="showNewPassword = !showNewPassword">
              <i class="login-eye-btn ph-custom ph-eye-fill"/>
            </div>
          </div>
        </b-form-group>

        <!-- New password repeat -->
        <b-form-group
          :label="$t('NewPassword.confirm')"
          label-for="newPasswordRepeat-input"
          :invalid-feedback="form.newPasswordRepeat.invalidFeedback"
          :state="form.newPasswordRepeat.state">
          <div class="login-password-container">
            <b-form-input
              id="newPasswordRepeat-input"
              class="password-input-with-an-eye"
              v-model="form.newPasswordRepeat.value"
              :state="form.newPasswordRepeat.state"
              :type="showNewPasswordRepeat ? 'text' : 'password'"
              autocomplete="off"
              required>
            </b-form-input>
            <div class="login-show-password-btn" @click="showNewPasswordRepeat = !showNewPasswordRepeat">
              <i class="login-eye-btn ph-custom ph-eye-fill"/>
            </div>
          </div>
        </b-form-group>

        <div class="mt-4">
          <b-button type="submit" class="btn-block" variant="primary">{{ $t('Validate') }}</b-button>
        </div>

      </form>
    </div>

    <div class="mt-5 text-right">
      <b-link v-on:click="backToLogin" class="forgot-password-link textual-link">{{ $t('backToLoginText') }}</b-link>
    </div>

  </div>
</template>

<script>

import api from '../../../services/api'

export default {

  name: 'ResetPasswordComponent',

  data() {
    return {
      showNewPassword: false,
      showNewPasswordRepeat: false,
      token: this.$route.params.token,
      userId: this.$route.params.userId,
      form: {
        newPassword: {
          value: null,
          state: null,
          invalidFeedback: null
        },
        newPasswordRepeat: {
          value: null,
          state: null,
          invalidFeedback: null
        }
      },
      ui: {
        showSuccess: false,
        showError: false,
        showErrorMessage: ''
      }
    }
  },

  emits: ['showLoginView'],

  mounted() {
    this.checkToken()
  },

  methods: {

    checkToken() {
      let data = new FormData()
      data.append('token', this.token)
      data.append('userId', this.userId)

      api({
        method: 'POST',
        url: `/forgotPassword/checkResetPasswordToken`,
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
          }
        })
    },

    handleSubmit() {
      if (!this.isFormValid()) {
        return
      }

      let formData = new FormData()
      formData.append('token', this.token)
      formData.append('userId', this.userId)
      formData.append('newPassword', this.form.newPassword.value.trim())

      api({
        method: 'POST',
        url: `/forgotPassword/resetPassword`,
        data: formData
      })
        .then(() => {
          this.ui.showSuccess = true
          this.ui.showError = false
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
          }
        })
    },

    isFormValid() {
      let valid = this.$refs.form.checkValidity()
      if (!valid) {
        this.$refs.form.reportValidity()
        return false
      }
      if (this.form.newPassword.value == null || this.form.newPassword.value.trim() === '') {
        this.form.newPassword.state = false
        this.form.newPassword.invalidFeedback = this.$i18n.t('MandatoryField')
        return false
      } else if (this.form.newPassword.value.trim().length < 8) {
        this.form.newPassword.state = false
        this.form.newPassword.invalidFeedback = this.$i18n.t('Password.minlenght.error')
        return false
      } else if (this.form.newPasswordRepeat.value == null || this.form.newPasswordRepeat.value.trim() === '') {
        this.form.newPasswordRepeat.state = false
        this.form.newPasswordRepeat.invalidFeedback = this.$i18n.t('MandatoryField')
        return false
      } else if (this.form.newPassword.value !== this.form.newPasswordRepeat.value) {
        this.form.newPasswordRepeat.state = false
        this.form.newPasswordRepeat.invalidFeedback = this.$i18n.t('NewPassword.not.corresponding')
        return false
      }
      return true
    },

    backToLogin() {
      this.$emit('showLoginView')
    }

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/auth/components/ResetPasswordComponent.vue